<template>
  <div class="d-none">
  </div>
</template>
<script>
import Vue from 'vue'
import _ from 'lodash'
import ComponentMixin from "@/components/ComponentMixin.js";
export default {
  name: "FormEditor",
  props: [...ComponentMixin.COMMON_PROPS],
  mixins: [ComponentMixin],
  data() {
    return {
      active: false,
      api: window.api
    };
  },
  mounted() {
    /*
    const k = new Date().getTime()
    if( k) return
    */
    console.log('FORMEDITOR.REGISTER EVENTLISTENER ')
    window.addEventListener("message", (event) => {
      window.console.log('Evento recibido desde la ventana de edicion>', event);
      if(event.type ==='message') {
        if( "updateSchema" === event?.data?.tipo )
          this.onRemoteUpdateSchema(event.data.payload)
      }
      if( "updateFormData" === event.data?.tipo ) {
          this.onRemoteUpdateFormData(event.data?.payload)
          window.api.eventPublish('on_remote_update_form_data', event.data)
      }
      if( "navigate" === event.data?.tipo ) {
          this.onRemoteNavigate(event.data.payload)
      }

    /**
     * Cuando esta viendo un formulario desde la aplicacion de soporte, se
     * quiere evitar:
     *  - tracking (para no crear una sesion monitorizable)
     *  - submit para que no se pueda enviar el formulario.
     * Ademas, se incluye una variable isSupportSession que indica que se trata
     * de una sesion de soporte o suplantada por alguien que ayuda al verdadero usuario.
     */
      this.api.setVariable('isSupportSession', event?.data?.isSupportSession)
      this.api.setVariable('disableTracking', event?.data?.disableTracking)
      this.api.setVariable('disableSubmit', event?.data?.disableSubmit)

    }, false);

  },
  methods: {

    applyAll(callback, node) {
      node = node || this.schema;
      callback(node);

      node.children = node.children || [];
      window._.each(node.children, child => {
        this.applyAll(callback, child);
      });
      return node;
    },

    onRemoteNavigate(payload) {
      if (payload.targetPage) this.api.setCurrentPage(payload.targetPage, payload.pageOnEnterPayload )
      if (payload.targetPageName) this.api.setPage(payload.targetPageName, payload.pageOnEnterPayload)
    },

    // Los combos no se actualizan tras fijar su valor con Vue. Este codigo
    // hace que se actualicen.
    /*
    updateAllCombos(newFormData) {
      newFormData;
      this.applyAll((node) => {

        let combos = [ ...document.getElementsByName(node.name), document.getElementById(node.name), document.getElementById(node.nodeUUID)]
        _.each(combos, combo => {
          return !combo || combo.dispatchEvent(new Event('setvalue'));
        });
      }, this.api.getSchema().elements);

      this.api.eventPublish(this.api.events.EVENT_ON_PAGE_CHANGE, {
        fromPage: this.api.getCurrentPageIndex() - 1,
        toPage: this.api.getCurrentPageIndex()
      })
    },
    */
   updateWidgets() {
    this.applyAll((node) => {
      _.each([ ...document.getElementsByName(node.name) ], widget => {
          return widget? widget.dispatchEvent(new Event('setvalue')) : null;
      })
    }, this.api.getSchema().elements);
   },

    onRemoteUpdateFormData(newFormData) {
      window.console.log('onRemoteUpdateFormData::evtJSON>', newFormData, this.api)
      this.api.setFormData(newFormData)
      this.api.clearValidationErrors()

      // primer actualizamos todos. Luego,
      // si hay combos que dependen unos de otros y
      // tienen que cargarse via REST, darles
      // algo de tiempo para que se actualicen
      Vue.nextTick( () => this.updateWidgets(), this)
      setTimeout( () => this.updateWidgets(), 5000)
    },

    onRemoteUpdateSchema(evtJSON) {
      // window.console.log('onRemoteUpdateSchema::evtJSON>', evtJSON)
      let schema = evtJSON.schema

      this.api.clearSubscriptions()
      this.api.setConfiguration(evtJSON.configuration)
      this.api.setSchema(schema)
      this.api.renewLastUpdate()
      this.$forceUpdate();

      this.$emit('change', schema)
      this.updateWidgets()

      this.api.eventPublish(this.api.events.EVENT_ON_PAGE_CHANGE, {
        detail: {
            fromPage: this.api.getCurrentPageIndex(),
            toPage: this.api.getCurrentPageIndex()
        }
      })

      const currentPageName = this.api.getCurrentPage()?.name
      setTimeout(() => {
        const pageStillThere = this.api.getPages().filter( p => p.name == currentPageName).length
        if (pageStillThere) this.api.setPage(currentPageName)

      }, 300)
    }
  }
};
</script>
<style>
</style>